import React from 'react'
import styled from 'styled-components'
import Modal from '../../Modal'

const ContentWrapper = styled.div`
  text-align: center;
`

interface ModalWithCatProps {
  isOpen: boolean
  onDismiss: () => void
  cat?: boolean
  children: React.ReactNode
}

export default function ModalWithCat({ isOpen, onDismiss, cat = true, children }: ModalWithCatProps) {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <ContentWrapper>{children}</ContentWrapper>
    </Modal>
  )
}
